import { YMaps, Map, ObjectManager } from '@pbe/react-yandex-maps';
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { map_api } from './api-map';
import styles from './map.module.css';
import { Button } from '../../../ui/button/Button';
export function MapComponent() {
  const { data, isLoading } = useQuery({ ...map_api.getContacts() });
  const [mapState, setMapState] = useState('dealer');
  const defaultState = {
    center: [55.751574, 37.573856],
    zoom: 5,
  };

  const [contentLayout, setContentLayout] = useState();
  const clusterIcons = [
    {
      href: 'map-icon.svg',
      size: [80, 80],
      // Offset so the image center matches the cluster center.
      offset: [-40, -40],
    },
    {
      href: 'map-icon.svg',
      size: [100, 100],
      offset: [-50, -50],
      // You can define the shape of the hotspot area
      // of the placemark.
      // The rectangular area is used by default.
      shape: {
        type: 'Circle',
        coordinates: [0, 0],
        radius: 30,
      },
    },
  ],
    // For a cluster size up to 100, the image small.jpg will be used.
    // For a cluster size over 100, big.png will be used.
    clusterNumbers = [100];
  return (
    <div>
      <div className={styles.buttons}>
        <Button
          data-active={mapState === 'dealer'}
          onClick={() => setMapState('dealer')}
          variant={"yellow"}

        >
          Дилер
        </Button>
        <Button
          data-active={mapState === 'rtt_nsto'}
          onClick={() => setMapState('rtt_nsto')}
          variant={"yellow"}

        >
          РТТ/СТО
        </Button>
      </div>
      {data && <div className={styles.map}>
        <YMaps query={{ lang: 'ru_RU' }}>
          <div className={styles.map_container}>
            <Map
              options={{
                suppressMapOpenBlock: true,
              }}
              width={'100%'}
              height={'100%'}
              style={{ width: '100%', height: '100%' }}
              className={styles.map}
              defaultState={defaultState}
              modules={['templateLayoutFactory']}
              onLoad={ymaps =>
                setContentLayout({
                  iconLayoutTemplate: ymaps.templateLayoutFactory.createClass(
                    `<div class="font-roboto" style="color: #black; font-weight: bold;">{{ properties.geoObjects.length }}</div>`
                  ),
                })
              }
            >
              <ObjectManager
                options={{
                  clusterize: true,
                  gridSize: 32,
                  iconColor: 'black',
                }}
                objects={{
                  openBalloonOnClick: true,
                  iconLayout: 'default#image',
                  // iconImageHref: '/images/svg/diller.svg',
                  iconImageSize: [40, 40],
                  iconImageOffset: [-20, -20],
                }}
                clusters={{
                  preset: 'islands#yellowClusterIcons',
                  clusterIcons: clusterIcons,
                  clusterNumbers: clusterNumbers,
                  clusterIconContentLayout: contentLayout?.iconLayoutTemplate,
                }}
                defaultFeatures={data}
                filter={feature => {
                  return feature.properties.data.contact_type === mapState;
                }}
                modules={['objectManager.addon.objectsBalloon', 'objectManager.addon.objectsHint']}
              />
            </Map>

          </div>
        </YMaps>
      </div>}
    </div>
  );
}
